import API_BASE from '../config';
import axios from 'axios';

const BACKEND_URL = API_BASE;
const API = `${BACKEND_URL}/api`;

export const apiService = {
  // Upload PDF for analysis
  async uploadProfile(file, targetRole, targetCompany = '', whatsappNumber = '') {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('targetRole', targetRole);
      formData.append('targetCompany', targetCompany);
      formData.append('whatsappNumber', whatsappNumber);

      const response = await axios.post(`${API}/analyze-profile`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      return response.data;
    } catch (error) {
      console.error('Upload error:', error);
      throw error;
    }
  },

  // Get analysis by ID
  async getAnalysis(analysisId) {
    try {
      const response = await axios.get(`${API}/analysis/${analysisId}`);
      return response.data;
    } catch (error) {
      console.error('Fetch analysis error:', error);
      throw error;
    }
  },

  // Get a stored evaluation result by ID (public /evaluation/:id route)
  async getEvaluationResult(evaluationId) {
    try {
      const response = await axios.get(`${API}/evaluation/result/${evaluationId}`);
      return response.data;
    } catch (error) {
      console.error('Fetch evaluation result error:', error);
      throw error;
    }
  },

  // Unlock full rewrite (after payment)
  async unlockRewrite(analysisId, paymentId) {
    try {
      const response = await axios.post(`${API}/unlock-rewrite`, {
        analysis_id: analysisId,
        payment_id: paymentId
      });
      return response.data;
    } catch (error) {
      console.error('Unlock error:', error);
      throw error;
    }
  },

  // Get pricing
  async getPricing() {
    try {
      const response = await axios.get(`${API}/pricing`);
      return response.data;
    } catch (error) {
      console.error('Pricing error:', error);
      throw error;
    }
  },

  // Get scarcity counter
  async getScarcity() {
    try {
      const response = await axios.get(`${API}/scarcity`);
      return response.data;
    } catch (error) {
      console.error('Scarcity error:', error);
      throw error;
    }
  }
};
